import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const PartiesResultRow = ({ row }) => (
  <table className="ir-search-table-results sticky-enabled">
    <tbody>
      <tr>
        <td>
          <span className="address-name" dangerouslySetInnerHTML={{ __html: row.party.name }} />
          {row.party.address &&
            <span style={{ whiteSpace: 'pre-wrap' }}><br />{row.party.address}</span>
          }
          {row.party.phone &&
            <div>t: {row.party.phone}</div>
          }
          {row.party.fax &&
            <div>f: {row.party.fax}</div>
          }
          {row.party.email &&
            <div>{row.party.email}</div>
          }
          {row.party.role &&
            <div><em>({row.party.role})</em></div>
          }
          {row.party.added_date &&
            <div><em>Added: {row.party.added_date}</em></div>
          }
        </td>
        {row.associated && row.associated.length > 0 &&
          <Fragment>
            <td>
              representing
            </td>
            <td>
              {row.associated.map((associated, idx) => (
                <p key={idx}>
                  <span className="address-name" dangerouslySetInnerHTML={{ __html: associated.name }} />
                  {associated.address &&
                    <span style={{ whiteSpace: 'pre-wrap' }}><br />{associated.address}</span>
                  }
                  {associated.phone &&
                    <span><br />t: {associated.phone}</span>
                  }
                  {associated.fax &&
                    <span><br />f: {associated.fax}</span>
                  }
                  {associated.email &&
                    <span><br />{associated.email}</span>
                  }
                  {associated.lead &&
                    <em><br />({associated.lead})</em>
                  }
                </p>
              ))}
            </td>
          </Fragment>
        }
      </tr>
    </tbody>
  </table>
);

PartiesResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default PartiesResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/PartiesResultRow.jsx